export function compareCaseIndependent(a, b) {
  if (!a) return 1;
  if (!b) return -1;

  a = a.toString();
  b = b.toString();

  return a.toLowerCase() > b.toLowerCase() ? 1 : -1;
}
